import { Intervention, NewIntervention, UpdateIntervention } from '../models';
import { PaginatedResponse } from '@/types';
import { CASES_PREFIX } from '@/pages/CustomerService/constants';
import { customerServiceApi } from '@/pages/CustomerService/services/customer-service.service';

const caseInterventionsApi = customerServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getInterventions: builder.query<
      PaginatedResponse<Intervention>,
      {
        caseId: string;
      }
    >({
      query: ({ caseId }) => ({
        url: `${CASES_PREFIX}/${caseId}/interventions`,
      }),
      providesTags: ['CaseInterventions'],
    }),
    createIntervention: builder.mutation<Intervention, NewIntervention>({
      query: (data) => ({
        url: `/interventions`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['CaseInterventions'],
    }),
    updateIntervention: builder.mutation<Intervention, UpdateIntervention>({
      query: (data) => ({
        url: `/interventions/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['CaseInterventions'],
    }),
    deleteIntervention: builder.mutation<Intervention, string>({
      query: (id) => ({
        url: `/interventions/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CaseInterventions'],
    }),
  }),
});

export const {
  useGetInterventionsQuery,
  useCreateInterventionMutation,
  useUpdateInterventionMutation,
  useDeleteInterventionMutation,
} = caseInterventionsApi;